"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _LayoutFullPageContentWrapper = require("./LayoutFullPageContentWrapper.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// external
// ours
// resources

/**
 * LayoutFullPageContentWrapper - Full page layout wrapper component
 * including header, mobile-nav, side-nav and content
 */
var LayoutFullPageContentWrapper = function LayoutFullPageContentWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return (
    /*#__PURE__*/
    // header is placed above teh progress par via styles but since they are placed via 'fixed' on mobile,
    // header must come after progress bar for correct layering.
    _react.default.createElement(_LayoutFullPageContentWrapper.ContentWrapper, {
      className: className
    }, children)
  );
};

LayoutFullPageContentWrapper.propTypes = {
  /** Any valid child content (strings and/or components)
   */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string
};
LayoutFullPageContentWrapper.defaultProps = {
  children: undefined,
  className: ''
};
var _default = LayoutFullPageContentWrapper;
exports.default = _default;